import { TApplicationState } from '../../types/redux';

export function getNewbuildingName(state: TApplicationState) {
  const {
    newbuilding: { name },
  } = state;

  return name;
}
